import { useRafState } from './useRafState';
import { useEffectOnce } from './useEffectOnce';
import { off, on } from './eventListener';
import type { SizeType } from './types';

export const useWindowSize = (): SizeType => {
  const [state, setState] = useRafState<SizeType>({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffectOnce(() => {
    const handler = (): void => {
      setState({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    on(window, 'resize', handler);

    return (): void => {
      off(window, 'resize', handler);
    };
  });

  return state;
};
